import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LandingPage.module.css';
import FeatureItem from '../../components/FeatureItem/FeatureItem';
import InstructionItem from '../../components/InstructionItem/InstructionItem';
import { LuMailSearch, LuCalendarDays } from 'react-icons/lu'
import { PiFolders, PiRanking } from 'react-icons/pi';
import { GoPeople } from 'react-icons/go';

function LandingPage() {
  localStorage.clear();
  const navigate = useNavigate();

  const goToLogin = () => navigate('/login');
  const goToSignup = () => navigate('/signup');

  return (
    <div className={styles.landingPageContainer}>
      <header className={styles.landingPageHeader}>
        <div className={styles.logo}>
          <img src="/icons/TTLogo.png" alt='Talent Track Logo' className={styles.logoImage} />
          <h1 className={styles.headerText}>Talent Track</h1>
        </div>
        <div className={styles.headerButtons}>
          <button className={styles.logInButton} onClick={goToLogin}>
            Log In
          </button>
          <button className={styles.signUpButton} onClick={goToSignup}>
            Sign Up
          </button>
        </div>
      </header>

      <main className={styles.hero}>
        <div className={styles.heroBackground}></div>
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h2 className={styles.heroTitle}>The Complete Recruiting Platform for <span style= {{color: '#783ff5'}}> Coaches</span></h2>
            <p className={styles.heroSubtitle}>
              AI-powered recruiting management that extracts Athlete information, organizes your pipeline, and automates communications, so you can focus on winning.
            </p>
          </div>
          <div className={styles.heroButtonContainer}>
            <div className={styles.heroButtons}>
              <h2 className={styles.buttonsTitle}> Get Started </h2>
              <p className={styles.buttonsSubtitle}> Join others and transform your recuriting process today</p>
              <button className={styles.trialButton} onClick={goToSignup}>
                Start Free Trial →
              </button>
              <button className={styles.howButton} onClick={() => {
                document.getElementById("instructions")?.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                })
              }}>
                How it Works
              </button>
            </div>
          </div>
        </div>
      </main>

      <section className={styles.featuresSection}>
        <h3 className={styles.sectionHeader}>Our Core Features</h3>
        <div className={styles.featureGrid}>
          <FeatureItem icon={<LuMailSearch />} title="Email Parsing" description="Extract athlete data from incoming emails automatically." />
          <FeatureItem icon={<PiFolders />} title="Organized Dashboard" description="Manage all recruits in a clean, structured view." />
          <FeatureItem icon={<PiRanking />} title="Prospect Ranking" description="Rank athletes based on your program's custom needs." />
          <FeatureItem icon={<LuCalendarDays />} title="Recruit Calendar" description="Automatically organize game schedules and set reminders." />
          <FeatureItem icon={<GoPeople />} title="Multi-Coach Access" description="Collaborate seamlessly with your entire recruiting team." />
        </div>
      </section>

      <section id="instructions" className={styles.instructionSection}>
        <h3 className={styles.sectionHeader}>How it Works</h3>
        <p className={styles.instructionSubtitle}>Get started with these simple steps</p>
        <div className={styles.instructionItems}>
          <InstructionItem number={1} title="Create Your Account" description="Set up your Talent Track account with an email and username. Customize your organization, and invite your coaching staff to collaborate." />
          <InstructionItem number={2} title="Forward Recruit Emails" description={
              <>
                Simply forward all your recruit emails to{" "}
                <span style={{ color: "#783ff5" }}>wizrecruitmain@gmail.com</span>.
                Manually parse new recruits with the push of a button, or Talent Track will do it automatically every hour.
              </>
            }
          />
          <InstructionItem number={3} title="Start Recruiting" description="View your recruits in a clean table, swtich between sports and filter by player metrics. Rate your recruits, and use the built-in calendar to never miss a game." />
        </div>
      </section>


      <footer className={styles.footer}>
        <p>© 2025 Talent Track. Designed for success. | Contact: wizrecruitmain@gmail.com</p>
      </footer>
    </div>
  );
}

export default LandingPage;